import React from 'react';
import {Text, View} from 'react-native';

import CheckBox from 'expo-checkbox';
import {styles} from './styles';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  changeValue?: any;
  value?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onPress?: any;
  text?: React.ReactNode;
}

const AcceptTermCheckbox = ({changeValue, value, onPress, text}: Props) => {
  return (
    <View style={[styles.container, {alignItems: 'flex-start'}]}>
      <View style={styles.checkboxContainer}>
        <CheckBox
          value={value}
          onValueChange={changeValue}
          style={styles.checkbox}
        />
        {text ? (
          text
        ) : (
          <Text style={styles.label}>
            Je reconnais avoir lu et compris les{' '}
            <Text style={{fontWeight: 'bold'}} onPress={onPress}>
              informations
            </Text>{' '}
            concernant le produit et je les accepte
          </Text>
        )}
      </View>
    </View>
  );
};

export default AcceptTermCheckbox;
